<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>异常记录</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="90px" size="mini">
        <div class=" inpBox">
          <el-form-item label="日期范围:" prop="timeData">
            <el-date-picker
              v-model="searchFrom.excepStart"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="searchFrom.excepEnd"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="车牌号:" prop="vehicleNo">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom.vehicleNo"></el-input>
          </el-form-item>
          <el-form-item label="车队:" prop="fleetIds">
            <el-select v-model="searchFrom.fleetIds" placeholder="请选择">
              <el-option
                v-for="(item,index) in fleetOptions"
                :key="index"
                :label="item.fleetName"
                :value="item.fleet">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode='001P006B001' v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode='001P006B002' v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="changeBtnClick" btnCode='001P006B003' v-if="btnFlg[2]">修改备注</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click = 'handleRowClick'
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="excep_no"   label="编号" align="center" ></el-table-column>
        <el-table-column prop="vehicle_no"   label="车牌号" align="center"></el-table-column>
        <el-table-column prop="fleet_name"   label="车队" align="center"  :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="driver_name" label="司机姓名"  align="center" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="driver_mobile"    label="手机号" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="excep_start"    label="开始时间"  width="180" align="center"></el-table-column>
        <el-table-column prop="excep_end" label="结束时间" align="center" width="180">
          <template slot-scope="scope"><div>
            <span v-if="scope.row.excep_end == undefined" >至今</span>
            <span v-if="scope.row.excep_end != undefined" >{{scope.row.excep_end}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="customerName"    label="车辆监控" width="180" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="handleHistoryClick(scope.row)" type="primary" size="small" btnCode='001P006B004' v-if="btnFlg[3]">异常轨迹</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="add_remark" label="备注" align="center" width="140" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--修改备注-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeremarks"
    @close="closeChange"
    width="500px"
    center>
    <div v-loading='loading1'>
      <span>
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="changeFrom.remarks"></el-input>
      </span>
      <div  style="margin:15px auto;width:130px;">
        <el-button type="primary" @click="determineClick" size='mini'>确定</el-button>
        <el-button @click="quXiao" size='mini'>关闭</el-button>
      </div>
    </div>
    </el-dialog>
    <!--历史轨迹-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="historicalTrack"
    @close="closeDialog" @opened="openedDialog"
    width="900px"
    center>
    <div v-loading="mapLoading">
      <span>
        <div class="mapBox">
          <div class="map" id="map"></div>
        </div>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="historicalTrack = false" size='mini'>关闭</el-button>
      </div>
    </div>
    </el-dialog>
  </div>
</template>
<script>
import AMap from 'AMap'
import {
  fleetList,
  getDictionaryList, // 字典
  getVehicleException, // 列表
  updateRemark, // 修改备注
  getVehicleHistory // 历史轨迹
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P006B001', '001P006B002', '001P006B003',
        '001P006B004'],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        fleetIds: ''
      },
      // 车队
      fleetOptions: [],
      value: '',
      tableList: [],
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      planStatus: '',
      // 修改备注弹框
      changeremarks: false,
      changeFrom: {
        remarks: ''
      },
      excepId: '',
      loading1: false,
      // 历史轨迹
      historicalTrack: false,
      marker: null,
      map: null,
      lngLat: [],
      tabLoading: false,
      mapLoading: false,
      excep_end: '',
      vehicle_no: '',
      excep_start: ''
    }
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.fleetOptionsInit()
    this.getDictionaryList()
    // this.getToDay()
    this.btnFlg = getBtn(this.btnIdArr, '/sgWaybill/abnormalRecord')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'fleet_name'
      }).then(res => {
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log('time:' + JSON.stringify(now))
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    /**
 * 日期格式化
 */
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let dateEndStr = this.dateFormat(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      let nowDate = (new Date()).getTime()
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) {
        this.searchFrom.collectPlanTime = this.timeStamp(new Date())
      } else {
        // 昨天的时间
        var day1 = new Date()
        day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000)
        var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
        this.searchFrom.collectPlanTime = s1
      }
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getVehicleException(this.searchFrom).then(res => {
        this.tabLoading = false
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.tabLoading = false
        // console.log(err.message)
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        fleetIds: ''
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    // 点击修改按钮
    changeBtnClick () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条数据进行修改！')
      } else {
        this.title = '修改备注'
        this.changeremarks = true
        this.excepId = selectData[0].excep_id
        this.changeFrom.remarks = selectData[0].add_remark
      }
    },
    // 修改备注确定
    determineClick () {
      this.loading1 = true
      updateRemark({
        id: this.excepId,
        addRemark: this.changeFrom.remarks
      }).then(res => {
        this.loading1 = false
        DonMessage.success('修改备注成功！')
        this.changeremarks = false
        this.changeFrom.remarks = ''
        this.getSeatchData(this.searchFrom)
      }).catch(err => {
        this.changeremarks = false
        DonMessage.error(err.message)
      })
    },
    // 修改备注取消
    quXiao () {
      this.changeFrom.remarks = ''
      this.changeremarks = false
    },
    // 弹窗关闭
    closeChange () {
      this.changeFrom.remarks = ''
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 点击历史轨迹
    handleHistoryClick (row) {
      if (this.marker) {
        this.map.clearMap()
        this.initMap()
      }
      this.title = '历史轨迹'
      this.historicalTrack = true
      this.excep_end = row.excep_end
      if (this.excep_end == undefined) {
        this.excep_end = ''
      }
      this.vehicle_no = row.vehicle_no
      this.excep_start = row.excep_start
      this.getVehicleHistory()
    },
    getVehicleHistory () {
      this.mapLoading = true
      getVehicleHistory({
        vehicleNo: this.vehicle_no,
        excepStart: this.excep_start,
        excepEnd: this.excep_end
      }).then(res => {
        this.mapLoading = false
        this.initMap()
        this.lngLat = res
        this.polylineFn()
      }).catch(err => {
        this.mapLoading = false
        this.$message.error(err.message)
      })
    },
    // 打开弹框
    openedDialog () {
      // this.initMap()
      // this.getVehicleHistory()
    },
    closeDialog () {
    },
    // 地图
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
    },
    polylineFn () {
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lngLat[0],
        icon: new AMap.Icon({
          image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/qi.png',
          size: new AMap.Size(30, 30), // 图标大小
          imageSize: new AMap.Size(30, 30),
          offset: new AMap.Pixel(-10, -34)
        }),
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lngLat[this.lngLat.length - 1],
        icon: new AMap.Icon({
          image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/zhong.png',
          size: new AMap.Size(30, 30), // 图标大小
          imageSize: new AMap.Size(30, 30),
          offset: new AMap.Pixel(-10, -34)
        }),
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      var passedPolyline = new AMap.Polyline({
        map: this.map,
        path: this.lngLat,
        strokeColor: '#2d70e4', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 3, // 线宽
        strokeStyle: 'solid' // 线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.map.setFitView()
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 25px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

//  /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//    width: 150px;
// }
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.mapBox{
  width: 100%;
  height: 560px;
  position: relative;
}
.map{
  width: 100%;
  height: 100%;
}
</style>
